import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'transflo-scheduler-main',
  templateUrl: './scheduler-main.component.html',
  styleUrls: ['./scheduler-main.component.scss']
})
export class SchedulerMainComponent implements OnInit {
  isUnauthorized = false;
  constructor(
    private activatedRoute: ActivatedRoute
  ) {
    const appParams = this.activatedRoute.snapshot.url[0].parameters;
    if (Object.keys(appParams).length !== 0 && appParams.hasOwnProperty('fleetId') &&
      appParams.hasOwnProperty('token')) {
      this.isUnauthorized = false;
      let token = appParams.token;
      token = token.replace(new RegExp('^Basic\\+'), '');
      localStorage.setItem('fleetId', appParams.fleetId);
      localStorage.setItem('token', token);
    } else {
      localStorage.clear();
      this.isUnauthorized = true;
    }
  }

  ngOnInit(): void {
  }

}
